import { render, staticRenderFns } from "./post-detail.vue?vue&type=template&id=80ea33e2&scoped=true&"
import script from "./post-detail.vue?vue&type=script&lang=js&"
export * from "./post-detail.vue?vue&type=script&lang=js&"
import style0 from "./post-detail.vue?vue&type=style&index=0&id=80ea33e2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80ea33e2",
  null
  
)

component.options.__file = "post-detail.vue"
export default component.exports